import { render } from "./Game.vue?vue&type=template&id=011defe2&bindings={\"task_letters\":\"setup\",\"s_content\":\"setup\",\"task_id\":\"setup\",\"s_custom\":\"setup\",\"particleEffect_1\":\"setup\"}"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script